import { render, staticRenderFns } from "./InviteSearch.vue?vue&type=template&id=72c4d42c&"
import script from "./InviteSearch.vue?vue&type=script&lang=js&"
export * from "./InviteSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports